(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.EvvelaCart) return;

    const REQUEST_TIMEOUT = 15000;
    const queue = [];
    let processing = false;
    let requestVersion = 0;
    let appliedVersion = 0;
    let appliedCountVersion = 0;
    let crossTabStale = false;
    const routesRoot = () => window.Shopify?.routes?.root || '/';
    const standardEventsReady = () => Promise.race([
      window.ShopifyStandardEventsReady || Promise.resolve(window.Shopify?.StandardEvents || null),
      new Promise((resolve) => window.setTimeout(() => resolve(null), 250))
    ]);

    const currentSectionsUrl = () => {
      const path = `${window.location.pathname}${window.location.search}`;
      if (!path.startsWith('/') || path.startsWith('//')) return null;
      try {
        const parsed = new URL(path, window.location.origin);
        if (parsed.origin !== window.location.origin) return null;
        return `${parsed.pathname}${parsed.search}`;
      } catch {
        return null;
      }
    };

    const sectionIds = () => {
      return [...new Set(Array.from(document.querySelectorAll('[data-cart-section-id]'))
        .map((element) => element.dataset.cartSectionId)
        .filter(Boolean))].slice(0, 5);
    };

    const surfaceFor = (source) => {
      const closest = source?.closest?.('[data-cart-surface]');
      if (closest?.isConnected) return closest;
      const type = closest?.dataset?.cartSurface;
      return (type ? document.querySelector(`[data-cart-surface="${type}"]`) : null)
        || document.querySelector('[data-cart-surface="drawer"]')
        || document.querySelector('[data-cart-surface="page"]');
    };
    const messageFor = (surface, name) => surface?.dataset?.[name] || '';

    const setBusy = (task, busy) => {
      const line = task.source?.closest?.('[data-cart-line]');
      if (line) {
        const allowQueuedQuantityInput = task.type === 'change' && !task.source?.matches?.('[data-cart-remove]');
        if (busy) line.setAttribute('aria-busy', 'true'); else line.removeAttribute('aria-busy');
        line.querySelectorAll('button, input, [data-cart-remove]').forEach((control) => {
          if (control.matches('button, input') && !allowQueuedQuantityInput) control.disabled = busy;
          if (control.matches('[data-cart-remove]') && !allowQueuedQuantityInput) control.setAttribute('aria-disabled', String(busy));
        });
      }
      if (task.type === 'add') {
        const submit = task.source?.querySelector?.('[data-product-submit]');
        if (submit) {
          submit.disabled = busy;
          if (busy) submit.setAttribute('aria-busy', 'true'); else submit.removeAttribute('aria-busy');
        }
      }
      if (task.type === 'note') {
        const button = task.source?.querySelector?.('[data-cart-note-save]') || task.source;
        if (button) {
          button.disabled = busy;
          if (busy) button.setAttribute('aria-busy', 'true'); else button.removeAttribute('aria-busy');
        }
      }
      if (task.type !== 'reconcile') {
        document.querySelectorAll('[data-cart-surface] button[name="checkout"], [data-cart-surface] button[name="update"]').forEach((button) => {
          button.disabled = busy;
        });
      }
    };

    const clearErrors = (surface) => {
      surface?.querySelectorAll('[data-cart-global-error], [data-cart-line-error]').forEach((error) => {
        error.hidden = true;
        error.textContent = '';
      });
    };

    const showError = (task, network = false) => {
      const surface = surfaceFor(task.source);
      const isQuantity = task.type === 'change';
      const message = task.stale
        ? messageFor(surface, 'cartStaleErrorMessage')
        : network
          ? messageFor(surface, 'cartNetworkErrorMessage')
          : messageFor(surface, isQuantity ? 'cartQuantityErrorMessage' : task.type === 'add' ? 'cartAddErrorMessage' : 'cartUpdateErrorMessage');
      const lineError = task.source?.closest?.('[data-cart-line]')?.querySelector?.('[data-cart-line-error]');
      const productError = task.type === 'add' ? task.source?.querySelector?.('[data-product-cart-error]') : null;
      const target = productError || (isQuantity && lineError ? lineError : surface?.querySelector?.('[data-cart-global-error]'));
      if (target) {
        target.textContent = message;
        target.hidden = false;
        target.focus?.({ preventScroll: false });
      }
      return message;
    };

    const announce = (surface, message) => {
      const region = surface?.querySelector?.('[data-cart-live-region]');
      if (!region || !message) return;
      region.textContent = '';
      window.requestAnimationFrame(() => { region.textContent = message; });
    };

    const updateCount = (count) => {
      const value = Number(count) || 0;
      const source = document.querySelector('[data-cart-surface]');
      const suffix = value === 1 ? 'One' : 'Other';
      const cartLabel = source?.dataset[`cartLabel${suffix}`]?.split('__COUNT__').join(String(value));
      const countLabel = source?.dataset[`cartCountLabel${suffix}`]?.split('__COUNT__').join(String(value));
      document.querySelectorAll('[data-cart-item-count]').forEach((surface) => { surface.dataset.cartItemCount = String(value); });
      document.querySelectorAll('[data-cart-count]').forEach((element) => {
        element.textContent = String(value);
        if (countLabel) element.setAttribute('aria-label', countLabel);
        element.hidden = element.dataset.hideZero === 'true' && value === 0;
      });
      document.querySelectorAll('[data-cart-link-label]').forEach((element) => { if (cartLabel) element.textContent = cartLabel; });
      document.querySelectorAll('[data-cart-count-text]').forEach((element) => { if (countLabel) element.textContent = countLabel; });
    };

    const updateCountForVersion = (count, version) => {
      if (version < appliedCountVersion) return;
      appliedCountVersion = version;
      updateCount(count);
    };

    const parseJsonResponse = async (response) => {
      const text = await response.text();
      let data;
      try {
        data = text ? JSON.parse(text) : {};
      } catch {
        const error = new Error('Malformed cart response');
        error.status = response.status;
        error.uncertain = true;
        throw error;
      }
      if (!response.ok) {
        const error = new Error('Cart request failed');
        error.status = response.status;
        error.payload = data;
        error.uncertain = ![404, 422].includes(response.status);
        throw error;
      }
      return data;
    };

    const fetchWithTimeout = async (url, options = {}) => {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), REQUEST_TIMEOUT);
      try {
        return await fetch(url, { ...options, signal: controller.signal });
      } finally {
        window.clearTimeout(timeout);
      }
    };

    const fetchCart = async () => {
      const response = await fetchWithTimeout(`${routesRoot()}cart.js`, { headers: { Accept: 'application/json' } });
      return parseJsonResponse(response);
    };

    const fetchSections = async (ids, sectionsUrl) => {
      if (!ids.length || !sectionsUrl) return {};
      const url = new URL(sectionsUrl, window.location.origin);
      url.searchParams.set('sections', ids.join(','));
      const response = await fetchWithTimeout(`${url.pathname}${url.search}`, { headers: { Accept: 'application/json' } });
      return parseJsonResponse(response);
    };

    const focusHint = (task) => {
      const line = task.source?.closest?.('[data-cart-line]');
      if (!line) return null;
      const lines = Array.from(line.parentElement?.querySelectorAll?.(':scope > [data-cart-line]') || []);
      let control = 'input';
      if (task.source?.matches?.('[data-cart-remove]')) control = 'remove';
      if (task.source?.matches?.('[data-cart-quantity-change]')) control = `[data-cart-quantity-change="${task.source.dataset.cartQuantityChange}"]`;
      return { key: line.dataset.lineKey, index: lines.indexOf(line), control };
    };

    const restoreFocus = (task, surface, hint) => {
      if (!surface || !hint) return;
      let line = Array.from(surface.querySelectorAll('[data-cart-line]')).find((candidate) => candidate.dataset.lineKey === hint.key);
      if (!line) {
        const lines = Array.from(surface.querySelectorAll('[data-cart-line]'));
        line = lines[Math.min(hint.index, lines.length - 1)] || lines[Math.max(0, hint.index - 1)];
      }
      let target;
      if (hint.control === 'remove') target = line?.querySelector('[data-cart-remove], [data-cart-quantity-input]');
      else if (hint.control === 'input') target = line?.querySelector('[data-cart-quantity-input]');
      else target = line?.querySelector(hint.control);
      (target || surface.querySelector('[data-cart-heading]'))?.focus?.({ preventScroll: true });
    };

    const replaceSurface = (id, html, task, hint) => {
      if (typeof html !== 'string' || !html.trim()) return false;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const escapedId = CSS.escape(id);
      const incoming = parsed.querySelector(`[data-cart-section-id="${escapedId}"]`);
      const current = document.querySelector(`[data-cart-section-id="${escapedId}"]`);
      const incomingFragment = incoming?.querySelector('[data-cart-render-fragment]');
      const currentFragment = current?.querySelector('[data-cart-render-fragment]');
      if (!incoming || !current || !incomingFragment || !currentFragment) return false;
      currentFragment.replaceWith(document.importNode(incomingFragment, true));
      current.dataset.cartItemCount = incoming.dataset.cartItemCount || current.dataset.cartItemCount;
      restoreFocus(task, current, hint);
      return true;
    };

    const applySections = (sections, ids, task, version) => {
      if (version < appliedVersion) return false;
      const hint = focusHint(task);
      let complete = true;
      ids.forEach((id) => {
        if (!replaceSurface(id, sections?.[id], task, hint)) complete = false;
      });
      if (complete) appliedVersion = version;
      return complete;
    };

    const eventContext = (task) => task.type === 'add' ? 'product' : surfaceFor(task.source)?.dataset.cartSurface === 'drawer' ? 'dialog' : 'cart';

    const beginStandardEvent = async (task) => {
      const events = await standardEventsReady();
      if (!events) return null;
      let EventClass;
      let payload;
      if (task.type === 'note') {
        EventClass = events.CartNoteUpdateEvent;
        payload = { context: eventContext(task), note: task.note };
      } else {
        EventClass = events.CartLinesUpdateEvent;
        const action = task.type === 'add' ? 'add' : task.quantity === 0 ? 'remove' : 'update';
        const variantId = task.formData?.get?.('id');
        const lines = task.type === 'add' && variantId
          ? [{ merchandiseId: `gid://shopify/ProductVariant/${variantId}`, quantity: Number(task.formData.get('quantity') || 1) }]
          : [{ id: task.key, quantity: task.quantity }];
        payload = { action, context: eventContext(task), lines };
      }
      if (!EventClass) return null;
      const deferred = EventClass.createPromise();
      deferred.promise.catch(() => {});
      const target = task.source || document;
      target.dispatchEvent(new EventClass({ ...payload, promise: deferred.promise }));
      return { events, EventClass, deferred, target };
    };

    const finishStandardEvent = (eventState, cartState) => {
      if (!eventState || !cartState) return;
      try {
        eventState.deferred.resolve({ cart: eventState.EventClass.createCartFromAjaxResponse(cartState) });
      } catch (error) {
        eventState.deferred.reject(error);
      }
    };

    const failStandardEvent = (eventState, error, message) => {
      if (!eventState) return;
      const code = [404, 422].includes(error?.status) ? 'INVALID' : 'SERVICE_UNAVAILABLE';
      if (eventState.events.CartErrorEvent) eventState.target.dispatchEvent(new eventState.events.CartErrorEvent({ error: message, code }));
      eventState.deferred.reject(error);
    };

    const mutationRequest = async (task, ids, sectionsUrl) => {
      const sections = ids.join(',');
      if (task.type === 'add') {
        const body = new FormData();
        task.formData.forEach((value, key) => body.append(key, value));
        if (sections) body.set('sections', sections);
        if (sectionsUrl) body.set('sections_url', sectionsUrl);
        const response = await fetchWithTimeout(`${routesRoot()}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
        return parseJsonResponse(response);
      }
      const body = task.type === 'note' ? { note: task.note } : { id: String(task.key), quantity: task.quantity };
      if (sections) body.sections = sections;
      if (sectionsUrl) body.sections_url = sectionsUrl;
      const endpoint = task.type === 'note' ? 'cart/update.js' : 'cart/change.js';
      const response = await fetchWithTimeout(`${routesRoot()}${endpoint}`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      return parseJsonResponse(response);
    };

    const reconcile = async (task, version) => {
      const ids = sectionIds();
      const sectionsUrl = currentSectionsUrl();
      const cartState = await fetchCart();
      let sections = {};
      try { sections = await fetchSections(ids, sectionsUrl); } catch {}
      applySections(sections, ids, task, version);
      updateCountForVersion(cartState.item_count, version);
      return cartState;
    };

    const broadcast = (() => {
      if (!('BroadcastChannel' in window)) return null;
      const channel = new BroadcastChannel('evvela-cart');
      channel.addEventListener('message', () => {
        crossTabStale = true;
        if (document.visibilityState === 'visible' && !processing) {
          crossTabStale = false;
          window.EvvelaCart.reconcile(document.querySelector('[data-cart-surface]')).catch(() => {});
        }
      });
      return channel;
    })();

    const runTask = async (task) => {
      const version = ++requestVersion;
      if (task.type === 'reconcile') {
        try {
          const cartState = await reconcile(task, version);
          task.waiters.forEach(({ resolve }) => resolve(cartState));
        } catch (error) {
          task.waiters.forEach(({ reject }) => reject(error));
        }
        return;
      }
      const ids = sectionIds();
      const sectionsUrl = currentSectionsUrl();
      if (task.type === 'change' && !task.source?.isConnected) {
        const liveLine = Array.from(document.querySelectorAll('[data-cart-line]')).find((line) => line.dataset.lineKey === task.key);
        if (liveLine) {
          if (task.source?.matches?.('[data-cart-remove]')) task.source = liveLine.querySelector('[data-cart-remove]');
          else if (task.source?.matches?.('[data-cart-quantity-change]')) task.source = liveLine.querySelector(`[data-cart-quantity-change="${task.source.dataset.cartQuantityChange}"]`);
          else task.source = liveLine.querySelector('[data-cart-quantity-input]');
        }
        if (!task.source?.isConnected) task.stale = true;
      }
      const surface = surfaceFor(task.source);
      clearErrors(surface);
      if (task.type === 'add') {
        const productError = task.source?.querySelector?.('[data-product-cart-error]');
        if (productError) { productError.hidden = true; productError.textContent = ''; }
      }
      setBusy(task, true);
      let eventState = null;
      try { eventState = await beginStandardEvent(task); } catch {}
      try {
        if (task.stale) {
          const staleError = new Error('Stale cart line');
          staleError.status = 409;
          staleError.uncertain = true;
          throw staleError;
        }
        const response = await mutationRequest(task, ids, sectionsUrl);
        const cartState = task.type === 'add' ? await fetchCart() : response;
        let sections = response.sections || {};
        const hasAllSections = ids.every((id) => typeof sections[id] === 'string' && sections[id].trim());
        if (!hasAllSections) sections = await fetchSections(ids, sectionsUrl);
        const rendered = applySections(sections, ids, task, version);
        updateCountForVersion(cartState.item_count, version);
        try { finishStandardEvent(eventState, cartState); } catch {}
        const currentSurface = surfaceFor(task.source) || document.querySelector('[data-cart-surface]');
        const successMessage = messageFor(currentSurface, task.type === 'add' ? 'cartAddedMessage' : task.type === 'note' ? 'cartNoteSavedMessage' : 'cartUpdatedMessage');
        announce(currentSurface, successMessage);
        if (!rendered) showError(task, false);
        if (task.type === 'note') {
          const noteStatus = currentSurface?.querySelector?.('[data-cart-note-status]');
          if (noteStatus) noteStatus.textContent = successMessage;
        }
        if (task.type === 'add' && rendered) {
          const drawer = document.querySelector('[data-cart-drawer]');
          if (drawer?.dataset.autoOpen === 'true') window.EvvelaCart.open(drawer, task.submitter || task.source?.querySelector?.('[data-product-submit]'));
        }
        broadcast?.postMessage({ version, itemCount: cartState.item_count });
        task.waiters.forEach(({ resolve }) => resolve(cartState));
      } catch (error) {
        let reconciled = null;
        const uncertain = error?.uncertain || error?.name === 'AbortError' || !error?.status || ![404, 422].includes(error.status);
        if (uncertain) {
          try { reconciled = await reconcile(task, version); } catch {}
        }
        const message = showError(task, !error?.status || error?.name === 'AbortError');
        try { failStandardEvent(eventState, error, message); } catch {}
        if (!uncertain && task.type === 'change') {
          const input = task.source?.closest?.('[data-cart-line]')?.querySelector?.('[data-cart-quantity-input]');
          if (input) input.value = input.defaultValue;
        }
        if (reconciled) updateCountForVersion(reconciled.item_count, version);
        task.waiters.forEach(({ reject }) => reject(error));
      } finally {
        setBusy(task, false);
        if (task.type === 'add' && task.source) delete task.source.dataset.cartSubmitting;
      }
    };

    const drain = async () => {
      if (processing) return;
      processing = true;
      while (queue.length) {
        const task = queue.shift();
        await runTask(task);
      }
      processing = false;
    };

    const enqueue = (task) => {
      return new Promise((resolve, reject) => {
        const coalesced = queue.find((queued) => {
          if (task.type === 'change') return queued.type === 'change' && queued.key === task.key;
          if (task.type === 'note') return queued.type === 'note';
          if (task.type === 'reconcile') return queued.type === 'reconcile';
          return false;
        });
        if (coalesced) {
          if (task.type === 'change') coalesced.quantity = task.quantity;
          if (task.type === 'note') coalesced.note = task.note;
          coalesced.source = task.source;
          coalesced.waiters.push({ resolve, reject });
        } else {
          queue.push({ ...task, waiters: [{ resolve, reject }] });
        }
        drain();
      });
    };

    window.EvvelaCart = {
      enqueue,
      async reconcile(source) { return enqueue({ type: 'reconcile', source }); },
      open(drawer, trigger) {
        const root = drawer?.matches?.('[data-cart-drawer]') ? drawer : document.querySelector('[data-cart-drawer]');
        const dialog = root?.querySelector?.('[data-cart-dialog]');
        if (!dialog) {
          window.location.assign(`${routesRoot()}cart`);
          return;
        }
        window.EvvelaDialog?.open(dialog, trigger, '[data-dialog-close]');
      }
    };

    if (!customElements.get('evvela-cart-drawer')) {
      customElements.define('evvela-cart-drawer', class extends HTMLElement {
        connectedCallback() { window.EvvelaDialog?.bind(this.querySelector('[data-cart-dialog]')); }
        open(trigger) { window.EvvelaCart.open(this, trigger); }
      });
    }

    if (!customElements.get('evvela-cart-quantity')) {
      customElements.define('evvela-cart-quantity', class extends HTMLElement {
        connectedCallback() {
          if (this.abortController) return;
          this.abortController = new AbortController();
          const signal = this.abortController.signal;
          const input = this.querySelector('[data-cart-quantity-input]');
          const submit = (source) => {
            if (!input) return;
            const numeric = Number(input.value);
            const quantity = Number.parseInt(input.value, 10);
            if (!Number.isInteger(numeric) || quantity < 0) {
              input.value = input.defaultValue;
              input.reportValidity();
              return;
            }
            const line = this.closest('[data-cart-line]');
            if (!line?.dataset.lineKey) return;
            window.EvvelaCart.enqueue({ type: 'change', key: line.dataset.lineKey, quantity, source }).catch(() => {});
          };
          this.querySelectorAll('[data-cart-quantity-change]').forEach((button) => {
            button.addEventListener('click', () => {
              if (!input) return;
              Number(button.dataset.cartQuantityChange) > 0 ? input.stepUp() : input.stepDown();
              submit(button);
            }, { signal });
          });
          input?.addEventListener('change', () => submit(input), { signal });
        }
        disconnectedCallback() { this.abortController?.abort(); this.abortController = null; }
      });
    }

    document.addEventListener('click', (event) => {
      const launcher = event.target.closest('[data-cart-launcher]');
      if (launcher?.dataset.cartActionMode === 'drawer' && document.querySelector('[data-cart-drawer]')) {
        event.preventDefault();
        window.EvvelaCart.open(document.querySelector('[data-cart-drawer]'), launcher);
        return;
      }
      const remove = event.target.closest('[data-cart-remove]');
      if (remove?.closest('[data-cart-surface]')) {
        event.preventDefault();
        const line = remove.closest('[data-cart-line]');
        if (!line?.dataset.lineKey || remove.getAttribute('aria-disabled') === 'true') return;
        window.EvvelaCart.enqueue({ type: 'change', key: line.dataset.lineKey, quantity: 0, source: remove }).catch(() => {});
        return;
      }
      const noteSave = event.target.closest('[data-cart-note-save]');
      if (noteSave && noteSave.type === 'button') {
        const note = noteSave.closest('[data-cart-note]');
        const value = note?.querySelector('[data-cart-note-input]')?.value || '';
        window.EvvelaCart.enqueue({ type: 'note', note: value, source: noteSave }).catch(() => {});
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (event.submitter?.matches?.('[data-cart-note-save]')) {
        event.preventDefault();
        const note = event.submitter.closest('[data-cart-note]');
        const value = note?.querySelector('[data-cart-note-input]')?.value || '';
        window.EvvelaCart.enqueue({ type: 'note', note: value, source: event.submitter }).catch(() => {});
        return;
      }
      if (!form.matches('[data-product-form]') || !document.querySelector('[data-cart-drawer]')) return;
      if (form.dataset.demoCatalogMode === 'true') {
        event.preventDefault();
        return;
      }
      if (event.submitter && !event.submitter.matches('[data-product-submit]')) return;
      if (!form.checkValidity() || form.dataset.cartSubmitting === 'true') {
        event.preventDefault();
        form.reportValidity();
        return;
      }
      event.preventDefault();
      form.dataset.cartSubmitting = 'true';
      const formData = event.submitter ? new FormData(form, event.submitter) : new FormData(form);
      window.EvvelaCart.enqueue({ type: 'add', formData, source: form, submitter: event.submitter }).catch(() => {});
    }, true);

    window.addEventListener('pageshow', (event) => {
      if (event.persisted) window.EvvelaCart.reconcile(document.querySelector('[data-cart-surface]')).catch(() => {});
    });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && crossTabStale && !processing) {
        crossTabStale = false;
        window.EvvelaCart.reconcile(document.querySelector('[data-cart-surface]')).catch(() => {});
      }
    });
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector?.('[data-cart-surface]') || event.target.matches?.('[data-cart-surface]')) {
        window.EvvelaCart.reconcile(event.target).catch(() => {});
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dialog-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.EvvelaDialog) return;

    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');
    const triggers = new WeakMap();
    const boundDialogs = new WeakSet();

    const focusableElements = (dialog) => {
      return Array.from(dialog.querySelectorAll(focusableSelector)).filter((element) => {
        return !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length > 0;
      });
    };

    const handleClose = (dialog) => {
      const trigger = triggers.get(dialog);
      const restoreFocus = dialog.dataset.restoreFocus !== 'false';
      delete dialog.dataset.restoreFocus;
      triggers.delete(dialog);
      if (restoreFocus && trigger?.isConnected) trigger.focus();
    };

    const trapFocus = (event, dialog) => {
      if (event.key !== 'Tab') return;
      const focusable = focusableElements(dialog);
      if (focusable.length === 0) {
        event.preventDefault();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    window.EvvelaDialog = {
      bind(dialog) {
        if (!dialog || boundDialogs.has(dialog)) return;
        boundDialogs.add(dialog);
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) this.close(dialog);
        });
        dialog.addEventListener('keydown', (event) => trapFocus(event, dialog));
        dialog.addEventListener('close', () => handleClose(dialog));
        dialog.querySelectorAll('[data-dialog-close]').forEach((button) => {
          button.addEventListener('click', () => this.close(dialog));
        });
      },

      open(dialog, trigger, focusSelector) {
        if (!dialog || dialog.open) return;
        this.bind(dialog);
        document.querySelectorAll('dialog[open]').forEach((openDialog) => {
          if (openDialog !== dialog) this.close(openDialog, false);
        });
        triggers.set(dialog, trigger);
        dialog.showModal();
        window.requestAnimationFrame(() => {
          const focusTarget = focusSelector ? dialog.querySelector(focusSelector) : focusableElements(dialog)[0];
          focusTarget?.focus();
        });
      },

      close(dialog, restoreFocus = true) {
        if (!dialog?.open) return;
        dialog.dataset.restoreFocus = String(restoreFocus);
        dialog.close();
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["discovery-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('evvela-discovery')) return;

    customElements.define('evvela-discovery', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.classList.add('is-ready');
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.dialog = this.querySelector('[data-filter-dialog]');
        this.trigger = this.querySelector('[data-filter-open]');

        this.trigger?.addEventListener('click', () => this.openDialog(), { signal });
        this.querySelectorAll('[data-filter-close]').forEach((button) => {
          button.addEventListener('click', () => this.closeDialog(), { signal });
        });
        window.EvvelaDialog?.bind(this.dialog);
        this.querySelectorAll('[data-sort-select]').forEach((select) => {
          select.addEventListener('change', () => select.form?.requestSubmit(), { signal });
        });
        window.addEventListener('resize', () => {
          if (window.matchMedia('(min-width: 75rem)').matches && this.dialog?.open) this.closeDialog(false);
        }, { signal });
      }

      disconnectedCallback() {
        this.classList.remove('is-ready');
        this.abortController?.abort();
        this.abortController = null;
      }

      openDialog() {
        if (!this.dialog || this.dialog.open || window.matchMedia('(min-width: 75rem)').matches) return;
        window.EvvelaDialog?.open(this.dialog, this.trigger, '[data-filter-close]');
      }

      closeDialog(restore = true) {
        if (!this.dialog?.open) return;
        window.EvvelaDialog?.close(this.dialog, restore);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!customElements.get('evvela-announcement')) {
      customElements.define('evvela-announcement', class extends HTMLElement {
        connectedCallback() {
          if (this.abortController) return;
          this.abortController = new AbortController();
          const signal = this.abortController.signal;
          const storageKey = this.dataset.sessionKey;

          try {
            if (storageKey && sessionStorage.getItem(storageKey) === 'dismissed') {
              this.hidden = true;
            }
          } catch (error) {
            this.hidden = false;
          }

          this.querySelector('[data-announcement-dismiss]')?.addEventListener('click', () => {
            this.hidden = true;
            document.dispatchEvent(new CustomEvent('evvela:announcement-change'));
            try {
              if (storageKey) sessionStorage.setItem(storageKey, 'dismissed');
            } catch (error) {
              this.hidden = true;
            }
          }, { signal });
        }

        disconnectedCallback() {
          this.abortController?.abort();
          this.abortController = null;
        }
      });
    }

    if (!customElements.get('evvela-header')) {
      customElements.define('evvela-header', class extends HTMLElement {
        connectedCallback() {
          if (this.abortController) return;
          this.abortController = new AbortController();
          this.hoverTimer = null;
          this.initializePanels();
          this.bindDesktopMenus();
          this.bindMobileSubmenus();
          this.bindDialogs();
          this.bindThemeEditor();
          this.bindPanelAnchor();
        }

        disconnectedCallback() {
          this.querySelectorAll('dialog[open]').forEach((dialog) => window.EvvelaDialog?.close(dialog, false));
          this.abortController?.abort();
          this.abortController = null;
          window.clearTimeout(this.hoverTimer);
          this.resizeObserver?.disconnect();
        }

        initializePanels() {
          this.querySelectorAll('[data-submenu-panel], [data-mobile-submenu]').forEach((panel) => {
            panel.hidden = true;
          });
          this.querySelectorAll('[data-submenu-toggle], [data-mobile-submenu-toggle]').forEach((toggle) => {
            toggle.setAttribute('aria-expanded', 'false');
          });
        }

        bindDesktopMenus() {
          const signal = this.abortController.signal;
          const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');

          this.querySelectorAll('[data-header-menu-item]').forEach((item) => {
            const toggle = item.querySelector('[data-submenu-toggle]');
            if (!toggle) return;

            toggle.addEventListener('click', () => {
              const shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';
              this.closeDesktopMenus(item);
              if (shouldOpen) this.openDesktopMenu(item);
            }, { signal });

            item.addEventListener('pointerenter', () => {
              if (!hoverCapable.matches) return;
              window.clearTimeout(this.hoverTimer);
              this.hoverTimer = window.setTimeout(() => {
                this.closeDesktopMenus(item);
                this.openDesktopMenu(item);
              }, 90);
            }, { signal });

            item.addEventListener('pointerleave', () => {
              if (!hoverCapable.matches) return;
              window.clearTimeout(this.hoverTimer);
              this.hoverTimer = window.setTimeout(() => this.closeDesktopMenu(item), 140);
            }, { signal });

            item.addEventListener('focusout', () => {
              window.setTimeout(() => {
                if (!item.contains(document.activeElement)) this.closeDesktopMenu(item);
              }, 0);
            }, { signal });
          });

          document.addEventListener('pointerdown', (event) => {
            if (!this.contains(event.target)) this.closeDesktopMenus();
          }, { signal });

          document.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape') return;
            const openItem = this.querySelector('[data-header-menu-item].is-open');
            if (!openItem) return;
            const toggle = openItem.querySelector('[data-submenu-toggle]');
            this.closeDesktopMenu(openItem);
            toggle?.focus();
          }, { signal });

          window.addEventListener('resize', () => this.closeDesktopMenus(), { signal });
          window.addEventListener('scroll', () => this.closeDesktopMenus(), { signal, passive: true });
        }

        openDesktopMenu(item) {
          const toggle = item.querySelector('[data-submenu-toggle]');
          const panel = toggle ? document.getElementById(toggle.getAttribute('aria-controls')) : null;
          if (!toggle || !panel) return;
          this.updatePanelAnchor();
          if (panel.matches('.header-dropdown')) {
            const itemRect = item.getBoundingClientRect();
            const pageMargin = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--page-margin')) || 24;
            const panelWidth = Math.min(352, window.innerWidth - (pageMargin * 2));
            const isRtl = getComputedStyle(this).direction === 'rtl';
            const logicalStart = isRtl ? window.innerWidth - itemRect.right : itemRect.left;
            panel.style.setProperty('--header-panel-inline-start', `${Math.max(pageMargin, Math.min(logicalStart, window.innerWidth - pageMargin - panelWidth))}px`);
          }
          panel.hidden = false;
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }

        closeDesktopMenu(item) {
          const toggle = item.querySelector('[data-submenu-toggle]');
          const panel = toggle ? document.getElementById(toggle.getAttribute('aria-controls')) : null;
          if (!toggle || !panel) return;
          panel.hidden = true;
          item.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        }

        closeDesktopMenus(exceptItem = null) {
          this.querySelectorAll('[data-header-menu-item].is-open').forEach((item) => {
            if (item !== exceptItem) this.closeDesktopMenu(item);
          });
        }

        bindMobileSubmenus() {
          const signal = this.abortController.signal;
          this.querySelectorAll('[data-mobile-submenu-toggle]').forEach((toggle) => {
            toggle.addEventListener('click', () => {
              const panel = document.getElementById(toggle.getAttribute('aria-controls'));
              if (!panel) return;

              if (panel.matches('[data-mobile-panel]')) {
                this.openMobilePanel(panel, toggle);
                return;
              }

              const expanded = toggle.getAttribute('aria-expanded') === 'true';
              toggle.setAttribute('aria-expanded', String(!expanded));
              panel.hidden = expanded;
            }, { signal });
          });

          this.querySelectorAll('[data-mobile-submenu-back]').forEach((button) => {
            button.addEventListener('click', () => {
              const currentPanel = button.closest('[data-mobile-panel]');
              const parentPanel = document.getElementById(button.dataset.mobileParent);
              if (!currentPanel || !parentPanel) return;

              const originToggle = Array.from(this.querySelectorAll('[data-mobile-submenu-toggle]')).find((toggle) => {
                return toggle.getAttribute('aria-controls') === currentPanel.id;
              });

              this.resetMobilePanel(currentPanel);
              currentPanel.hidden = true;
              parentPanel.hidden = false;
              originToggle?.setAttribute('aria-expanded', 'false');
              originToggle?.focus();
            }, { signal });
          });
        }

        openMobilePanel(panel, toggle) {
          const nav = panel.closest('[data-mobile-nav]');
          if (!nav) return;
          nav.querySelectorAll(':scope > [data-mobile-panel]').forEach((candidate) => {
            candidate.hidden = candidate !== panel;
          });
          toggle.setAttribute('aria-expanded', 'true');
          panel.querySelector('[data-mobile-submenu-back], a, button')?.focus();
        }

        resetMobilePanel(panel) {
          panel.querySelectorAll('[data-mobile-submenu]').forEach((submenu) => {
            if (!submenu.matches('[data-mobile-panel]')) submenu.hidden = true;
          });
          panel.querySelectorAll('[data-mobile-submenu-toggle]').forEach((toggle) => {
            toggle.setAttribute('aria-expanded', 'false');
          });
        }

        resetMobileNavigation() {
          const nav = this.querySelector('[data-mobile-nav]');
          if (!nav) return;
          const panels = Array.from(nav.querySelectorAll(':scope > [data-mobile-panel]'));
          panels.forEach((panel, index) => {
            this.resetMobilePanel(panel);
            panel.hidden = index !== 0;
          });
        }

        bindDialogs() {
          const signal = this.abortController.signal;
          const mobileDialog = this.querySelector('[data-mobile-dialog]');
          const searchDialog = this.querySelector('[data-search-dialog]');
          const localizationDialog = this.querySelector('[data-localization-dialog]');

          this.querySelector('[data-mobile-open]')?.addEventListener('click', (event) => {
            this.closeDesktopMenus();
            this.resetMobileNavigation();
            window.EvvelaDialog?.open(mobileDialog, event.currentTarget, '[data-dialog-close]');
          }, { signal });

          mobileDialog?.addEventListener('close', () => this.resetMobileNavigation(), { signal });

          this.querySelector('[data-search-open]')?.addEventListener('click', (event) => {
            this.closeDesktopMenus();
            window.EvvelaDialog?.open(searchDialog, event.currentTarget, '[data-search-input]');
          }, { signal });

          this.querySelector('[data-localization-open]')?.addEventListener('click', (event) => {
            this.closeDesktopMenus();
            window.EvvelaDialog?.open(localizationDialog, event.currentTarget, '[data-localization-select]');
          }, { signal });

          this.querySelectorAll('[data-dialog-close]').forEach((button) => {
            button.addEventListener('click', () => window.EvvelaDialog?.close(button.closest('dialog')), { signal });
          });

          this.querySelectorAll('dialog').forEach((dialog) => {
            window.EvvelaDialog?.bind(dialog);
          });

          this.querySelector('[data-search-clear]')?.addEventListener('click', (event) => {
            event.preventDefault();
            const input = this.querySelector('[data-search-input]');
            if (!input) return;
            input.value = '';
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.focus();
          }, { signal });
        }

        bindThemeEditor() {
          const signal = this.abortController.signal;
          document.addEventListener('shopify:block:select', (event) => {
            const blockId = event.detail?.blockId;
            if (!blockId) return;
            const block = Array.from(this.querySelectorAll('[data-mega-block-id]')).find((element) => {
              return element.dataset.megaBlockId === blockId;
            });
            const item = block?.closest('[data-header-menu-item]');
            if (!item) return;
            this.closeDesktopMenus(item);
            this.openDesktopMenu(item);
          }, { signal });
        }

        bindPanelAnchor() {
          const signal = this.abortController.signal;
          this.resizeObserver = new ResizeObserver(() => this.updatePanelAnchor());
          this.resizeObserver.observe(this);
          window.addEventListener('resize', () => this.updatePanelAnchor(), { signal });
          document.addEventListener('shopify:section:load', () => this.updatePanelAnchor(), { signal });
          document.addEventListener('evvela:announcement-change', () => this.updatePanelAnchor(), { signal });
          document.fonts?.ready.then(() => {
            if (this.isConnected) this.updatePanelAnchor();
          });
          this.updatePanelAnchor();
        }

        updatePanelAnchor() {
          this.style.setProperty('--header-panel-block-start', `${this.getBoundingClientRect().bottom}px`);
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('evvela-predictive-search')) return;
    let predictiveUnavailableForPage = false;

    customElements.define('evvela-predictive-search', class extends HTMLElement {
      connectedCallback() {
        if (this.lifecycleController) return;
        this.lifecycleController = new AbortController();
        const signal = this.lifecycleController.signal;
        this.input = this.querySelector('[data-predictive-input]');
        this.form = this.input?.form;
        this.results = this.querySelector('[data-predictive-results]');
        this.status = this.querySelector('[data-predictive-status]');
        this.dialog = this.closest('dialog');
        this.timer = null;
        this.requestController = null;
        this.lastQuery = '';
        this.disabledForSession = predictiveUnavailableForPage || this.dataset.enabled !== 'true' || !this.dataset.resourceTypes;
        const featureManifest = document.getElementById('shopify-features');
        if (featureManifest) {
          try {
            this.disabledForSession = this.disabledForSession || JSON.parse(featureManifest.textContent).predictiveSearch === false;
          } catch {}
        }
        if (!this.input || !this.results || this.disabledForSession) return;

        this.input.addEventListener('input', () => this.handleInput(), { signal });
        this.form?.addEventListener('reset', () => window.setTimeout(() => this.clear(), 0), { signal });
        this.dialog?.addEventListener('close', () => this.clear(), { signal });
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        this.requestController?.abort();
        this.lifecycleController?.abort();
        this.lifecycleController = null;
      }

      handleInput() {
        if (this.disabledForSession) {
          this.clear();
          return;
        }
        window.clearTimeout(this.timer);
        this.requestController?.abort();
        const query = this.input.value.trim();
        const minimum = Number.parseInt(this.dataset.minLength || '2', 10);
        if (query.length < minimum) {
          this.clear();
          return;
        }
        this.lastQuery = query;
        this.status.textContent = this.status.dataset.loadingText || '';
        this.timer = window.setTimeout(() => this.fetchResults(query), 250);
      }

      async fetchResults(query) {
        this.requestController?.abort();
        this.requestController = new AbortController();
        const url = new URL(this.dataset.endpoint, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', this.dataset.resourceTypes);
        url.searchParams.set('resources[limit]', this.dataset.resultLimit || '4');
        url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('section_id', 'predictive-search');

        try {
          const response = await fetch(url.toString(), { signal: this.requestController.signal });
          if (response.status === 417) {
            predictiveUnavailableForPage = true;
            this.disabledForSession = true;
          }
          if (!response.ok) throw new Error('Predictive search unavailable');
          const text = await response.text();
          if (query !== this.lastQuery || query !== this.input.value.trim()) return;
          const section = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
          if (!section) throw new Error('Predictive search section missing');
          this.results.innerHTML = section.innerHTML;
          this.results.hidden = false;
          this.input.setAttribute('aria-expanded', 'true');
          this.status.textContent = this.results.querySelector('.predictive-search__empty')?.textContent.trim() || this.status.dataset.resultsText || '';
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.clear();
        }
      }

      clear() {
        window.clearTimeout(this.timer);
        this.requestController?.abort();
        this.lastQuery = '';
        if (this.results) {
          this.results.replaceChildren();
          this.results.hidden = true;
        }
        this.input?.setAttribute('aria-expanded', 'false');
        if (this.status) this.status.textContent = '';
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!customElements.get('evvela-quantity')) {
      customElements.define('evvela-quantity', class extends HTMLElement {
        connectedCallback() {
          if (this.abortController) return;
          this.abortController = new AbortController();
          const input = this.querySelector('input[type="number"]');
          this.querySelectorAll('[data-quantity-change]').forEach((button) => {
            button.addEventListener('click', () => {
              if (!input) return;
              const direction = Number(button.dataset.quantityChange);
              if (direction > 0) input.stepUp(); else input.stepDown();
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }, { signal: this.abortController.signal });
          });
        }

        disconnectedCallback() {
          this.abortController?.abort();
          this.abortController = null;
        }
      });
    }

    if (!customElements.get('evvela-product-gallery')) {
      customElements.define('evvela-product-gallery', class extends HTMLElement {
        connectedCallback() {
          if (this.abortController) return;
          this.abortController = new AbortController();
          const signal = this.abortController.signal;
          const viewport = this.querySelector('[data-product-media-viewport]');
          const zoomDialog = this.querySelector('[data-product-zoom-dialog]');
          const currentCounter = this.querySelector('[data-product-media-current]');
          window.EvvelaDialog?.bind(zoomDialog);

          const setActiveMedia = (active) => {
            if (!active) return;
            const items = Array.from(this.querySelectorAll('[data-product-media-id]'));
            const activeIndex = items.indexOf(active);
            if (currentCounter && activeIndex >= 0) currentCounter.textContent = String(activeIndex + 1);
            this.querySelectorAll('[data-product-thumbnail]').forEach((thumbnail) => {
              const selected = thumbnail.dataset.productThumbnail === active.dataset.productMediaId;
              thumbnail.classList.toggle('is-active', selected);
              if (selected) thumbnail.setAttribute('aria-current', 'true'); else thumbnail.removeAttribute('aria-current');
            });
          };

          this.querySelectorAll('[data-product-thumbnail]').forEach((button) => {
            button.addEventListener('click', () => {
              const media = this.querySelector(`[data-product-media-id="${CSS.escape(button.dataset.productThumbnail)}"]`);
              this.querySelectorAll('[data-product-media-id]').forEach((item) => item.classList.toggle('is-active', item === media));
              this.querySelectorAll('video').forEach((video) => {
                if (!media?.contains(video)) video.pause();
              });
              media?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
              setActiveMedia(media);
            }, { signal });
          });

          viewport?.addEventListener('scrollend', () => {
            const items = Array.from(this.querySelectorAll('[data-product-media-id]'));
            const viewportRect = viewport.getBoundingClientRect();
            const viewportCenter = viewportRect.left + (viewportRect.width / 2);
            const active = items.reduce((nearest, item) => {
              const itemRect = item.getBoundingClientRect();
              const nearestRect = nearest.getBoundingClientRect();
              const itemDistance = Math.abs(itemRect.left + (itemRect.width / 2) - viewportCenter);
              const nearestDistance = Math.abs(nearestRect.left + (nearestRect.width / 2) - viewportCenter);
              return itemDistance < nearestDistance ? item : nearest;
            }, items[0]);
            setActiveMedia(active);
          }, { signal });

          const zoomTriggers = Array.from(this.querySelectorAll('[data-product-zoom-open]'));
          const zoomContainer = zoomDialog?.querySelector('[data-product-zoom-container]');
          const zoomCounter = zoomDialog?.querySelector('[data-product-zoom-counter]');
          const reducedZoomMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          let zoomIndex = 0;
          let zoomRequest = 0;

          // EVVELA interactive detail inspection. Coordinates remain within the
          // actual contained image, rather than treating its letterboxing as pixels.
          const clampZoom = (value, min, max) => Math.min(max, Math.max(min, value));
          let detailScale = 1;
          let detailPanX = 0;
          let detailPanY = 0;
          let detailGestureUsed = false;
          let detailPinch = null;
          let detailDrag = null;
          let detailLastTap = null;
          const zoomImage = () => zoomContainer?.querySelector('.product-zoom__image');
          const contentSize = () => {
            const image = zoomImage();
            if (!image) return null;
            const width = image.offsetWidth;
            const height = image.offsetHeight;
            const ratio = (image.naturalWidth || image.width) / (image.naturalHeight || image.height);
            if (!width || !height || !Number.isFinite(ratio) || ratio <= 0) return null;
            const displayWidth = Math.min(width, height * ratio);
            const displayHeight = Math.min(height, width / ratio);
            return { width, height, displayWidth, displayHeight };
          };
          const panLimits = () => {
            const geometry = contentSize();
            if (!geometry) return { x: 0, y: 0 };
            return {
              x: Math.max(0, (geometry.displayWidth * detailScale - geometry.width) / 2),
              y: Math.max(0, (geometry.displayHeight * detailScale - geometry.height) / 2)
            };
          };
          const updateDetailTransform = (moving = false) => {
            const image = zoomImage();
            if (!image) return;
            const limits = panLimits();
            detailPanX = clampZoom(detailPanX, -limits.x, limits.x);
            detailPanY = clampZoom(detailPanY, -limits.y, limits.y);
            image.style.transitionDuration = moving ? '0ms' : '';
            image.style.transform = 'translate3d(' + detailPanX.toFixed(2) + 'px,' + detailPanY.toFixed(2) + 'px,0) scale(' + detailScale.toFixed(3) + ')';
            zoomContainer?.classList.toggle('is-magnified', detailScale > 1.01);
          };
          const resetDetailZoom = () => {
            detailScale = 1;
            detailPanX = 0;
            detailPanY = 0;
            detailPinch = null;
            detailDrag = null;
            detailLastTap = null;
            detailGestureUsed = false;
            updateDetailTransform();
          };
          const detailRect = () => zoomContainer.getBoundingClientRect();
          const detailCenter = () => {
            const box = detailRect();
            return { x: box.left + box.width / 2, y: box.top + box.height / 2 };
          };
          const distanceBetween = (a, b) => Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
          const pointBetween = (a, b) => ({
            x: (a.clientX + b.clientX) / 2,
            y: (a.clientY + b.clientY) / 2
          });
          const desktopPointerMove = (event) => {
            if (!zoomDialog?.open || event.pointerType === 'touch' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
            const image = zoomImage();
            const geometry = contentSize();
            if (!image || !geometry) return;
            detailScale = 2;
            const center = detailCenter();
            const limits = panLimits();
            detailPanX = -clampZoom((event.clientX - center.x) / Math.max(1, geometry.displayWidth / 2), -1, 1) * limits.x;
            detailPanY = -clampZoom((event.clientY - center.y) / Math.max(1, geometry.displayHeight / 2), -1, 1) * limits.y;
            updateDetailTransform(true);
          };
          zoomContainer?.addEventListener('pointerenter', desktopPointerMove, { signal });
          zoomContainer?.addEventListener('pointermove', desktopPointerMove, { signal });
          zoomContainer?.addEventListener('pointerleave', (event) => {
            if (event.pointerType !== 'touch' && detailScale > 1) resetDetailZoom();
          }, { signal });
          zoomContainer?.addEventListener('touchstart', (event) => {
            if (!zoomImage()) return;
            if (event.touches.length === 2) {
              detailGestureUsed = true;
              const [a, b] = Array.from(event.touches);
              const midpoint = pointBetween(a, b);
              const center = detailCenter();
              detailPinch = {
                distance: Math.max(1, distanceBetween(a, b)),
                scale: detailScale,
                anchorX: (midpoint.x - center.x - detailPanX) / detailScale,
                anchorY: (midpoint.y - center.y - detailPanY) / detailScale
              };
              detailDrag = null;
            } else if (event.touches.length === 1) {
              const point = event.touches[0];
              detailDrag = {
                startX: point.clientX,
                startY: point.clientY,
                panX: detailPanX,
                panY: detailPanY,
                moved: false
              };
            }
          }, { passive: true, signal });
          zoomContainer?.addEventListener('touchmove', (event) => {
            if (!zoomImage()) return;
            if (event.touches.length >= 2) {
              if (!detailPinch) return;
              event.preventDefault();
              detailGestureUsed = true;
              const [a, b] = Array.from(event.touches);
              const midpoint = pointBetween(a, b);
              const center = detailCenter();
              detailScale = clampZoom(detailPinch.scale * distanceBetween(a, b) / detailPinch.distance, 1, 3);
              detailPanX = midpoint.x - center.x - detailPinch.anchorX * detailScale;
              detailPanY = midpoint.y - center.y - detailPinch.anchorY * detailScale;
              updateDetailTransform(true);
            } else if (event.touches.length === 1 && detailScale > 1 && detailDrag && !detailPinch) {
              event.preventDefault();
              const point = event.touches[0];
              if (Math.abs(point.clientX - detailDrag.startX) + Math.abs(point.clientY - detailDrag.startY) > 8) detailDrag.moved = true;
              detailGestureUsed = true;
              detailPanX = detailDrag.panX + point.clientX - detailDrag.startX;
              detailPanY = detailDrag.panY + point.clientY - detailDrag.startY;
              updateDetailTransform(true);
            }
          }, { passive: false, signal });
          zoomContainer?.addEventListener('touchend', (event) => {
            if (detailPinch) {
              detailGestureUsed = true;
              detailPinch = null;
              if (event.touches.length === 1) {
                const point = event.touches[0];
                detailDrag = { startX: point.clientX, startY: point.clientY, panX: detailPanX, panY: detailPanY, moved: false };
              } else detailDrag = null;
              if (detailScale < 1.02) {
                resetDetailZoom();
                detailGestureUsed = true;
              }
              return;
            }
            if (event.touches.length || !event.changedTouches.length) return;
            const point = event.changedTouches[0];
            const now = Date.now();
            const doubleTapped = detailLastTap
              && now - detailLastTap.time < 340
              && Math.hypot(point.clientX - detailLastTap.x, point.clientY - detailLastTap.y) < 28
              && !detailDrag?.moved;
            if (doubleTapped) {
              detailGestureUsed = true;
              if (detailScale > 1.01) {
                resetDetailZoom();
                detailGestureUsed = true;
              } else {
                detailScale = 2.5;
                const center = detailCenter();
                detailPanX = (center.x - point.clientX) * (detailScale - 1);
                detailPanY = (center.y - point.clientY) * (detailScale - 1);
                updateDetailTransform();
              }
              detailLastTap = null;
            } else {
              detailLastTap = { time: now, x: point.clientX, y: point.clientY };
            }
            detailDrag = null;
          }, { passive: true, signal });
          zoomContainer?.addEventListener('touchcancel', () => {
            detailPinch = null;
            detailDrag = null;
            detailGestureUsed = true;
          }, { passive: true, signal });
          window.addEventListener('resize', () => {
            if (zoomDialog?.open) updateDetailTransform();
          }, { signal });


          const renderZoom = (nextIndex) => {
            if (!zoomContainer || zoomTriggers.length === 0) return;
            resetDetailZoom();
            zoomIndex = (nextIndex + zoomTriggers.length) % zoomTriggers.length;
            const trigger = zoomTriggers[zoomIndex];
            const requestId = ++zoomRequest;
            const image = document.createElement('img');
            image.className = 'product-zoom__image';
            image.alt = trigger.dataset.zoomAlt || '';
            image.width = Number(trigger.dataset.zoomWidth) || 1600;
            image.height = Number(trigger.dataset.zoomHeight) || 2000;
            image.decoding = 'async';
            if (zoomDialog) zoomDialog.dataset.zoomOrientation = image.width > image.height * 1.08 ? 'landscape' : 'portrait';
            zoomContainer.dataset.loading = 'true';
            const showImage = () => {
              if (requestId !== zoomRequest) return;
              zoomContainer.replaceChildren(image);
              zoomContainer.dataset.loading = 'false';
              zoomDialog.dataset.zoomOrientation = (image.naturalWidth || image.width) > (image.naturalHeight || image.height) * 1.08 ? 'landscape' : 'portrait';
              updateDetailTransform();
            };
            image.addEventListener('load', showImage, { once: true });
            image.addEventListener('error', () => {
              if (requestId === zoomRequest) zoomContainer.dataset.loading = 'false';
            }, { once: true });
            image.src = trigger.dataset.zoomSrc;
            if (image.complete && image.naturalWidth > 0) showImage();
            if (zoomCounter) zoomCounter.textContent = String(zoomIndex + 1).padStart(2, '0') + ' / ' + String(zoomTriggers.length).padStart(2, '0');
            const preloadTrigger = zoomTriggers[(zoomIndex + 1) % zoomTriggers.length];
            if (preloadTrigger && preloadTrigger !== trigger) {
              const preload = new Image();
              preload.src = preloadTrigger.dataset.zoomSrc;
            }
          };

          zoomTriggers.forEach((trigger, index) => {
            trigger.addEventListener('click', (event) => {
              if (!zoomDialog) return;
              event.preventDefault();
              renderZoom(index);
              window.EvvelaDialog?.open(zoomDialog, trigger, '[data-dialog-close]');
            }, { signal });
          });

          zoomDialog?.querySelectorAll('[data-product-zoom-step]').forEach((button) => {
            button.addEventListener('click', () => renderZoom(zoomIndex + Number(button.dataset.productZoomStep)), { signal });
          });

          zoomDialog?.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            const direction = document.documentElement.dir === 'rtl' ? -1 : 1;
            event.preventDefault();
            renderZoom(zoomIndex + (event.key === 'ArrowRight' ? direction : -direction));
          }, { signal });

          let touchStartX = null;
          let touchStartY = null;
          zoomDialog?.addEventListener('touchstart', (event) => {
            if (event.touches.length === 1 && detailScale <= 1.01) detailGestureUsed = false;
            if (event.touches.length !== 1) return;
            touchStartX = event.touches[0].clientX;
            touchStartY = event.touches[0].clientY;
          }, { passive: true, signal });
          zoomDialog?.addEventListener('touchend', (event) => {
            if (detailGestureUsed || detailScale > 1.01) { touchStartX = null; touchStartY = null; return; }
            if (touchStartX === null || !event.changedTouches.length) return;
            const dx = event.changedTouches[0].clientX - touchStartX;
            const dy = event.changedTouches[0].clientY - touchStartY;
            touchStartX = null;
            touchStartY = null;
            if (Math.abs(dx) < 55 || Math.abs(dx) < Math.abs(dy) * 1.25) return;
            const direction = document.documentElement.dir === 'rtl' ? 1 : -1;
            renderZoom(zoomIndex + (dx > 0 ? -direction : direction));
          }, { passive: true, signal });

          zoomDialog?.addEventListener('close', () => {
            zoomRequest += 1;
            resetDetailZoom();
            if (zoomContainer) {
              zoomContainer.dataset.loading = 'false';
              zoomContainer.replaceChildren();
            }
          }, { signal });

        }

        disconnectedCallback() {
          this.abortController?.abort();
          this.abortController = null;
        }
      });
    }

    if (!customElements.get('evvela-product')) {
      customElements.define('evvela-product', class extends HTMLElement {
        connectedCallback() {
          if (this.abortController) return;
          this.abortController = new AbortController();
          const signal = this.abortController.signal;
          this.querySelector('.product-sticky[data-enabled="true"]')?.removeAttribute('hidden');
          const form = this.querySelector('[data-product-form]');
          const picker = this.querySelector('[data-product-picker]');
          const query = new URLSearchParams(location.search);
          const invalidVariantQuery = query.has('variant') && this.dataset.explicitVariant !== 'true';
          const invalidOptionValuesQuery = query.has('option_values') && this.dataset.activeVariant !== 'true';
          const invalidExplicitQuery = invalidVariantQuery || invalidOptionValuesQuery;

          if (invalidExplicitQuery) {
            this.dataset.purchaseAvailable = 'false';
            const variantInput = this.querySelector('[data-product-variant-id]');
            const submit = this.querySelector('[data-product-submit]');
            if (variantInput) {
              variantInput.value = '';
              variantInput.disabled = true;
            }
            if (submit) {
              submit.disabled = true;
              submit.querySelector('[data-product-submit-label]').textContent = this.dataset.unavailableLabel;
            }
            this.querySelectorAll('.shopify-payment-button').forEach((button) => button.hidden = true);
            const stickyLabel = this.querySelector('[data-sticky-purchase-label]');
            if (stickyLabel) stickyLabel.textContent = this.dataset.chooseOptionsLabel;
            this.querySelectorAll('[data-variant-dependent]').forEach((element) => element.hidden = true);
          }

          this.querySelectorAll('[data-variant-url-form]').forEach((urlForm) => {
            urlForm.addEventListener('submit', (event) => {
              event.preventDefault();
              const url = urlForm.querySelector('[data-variant-url-select]')?.value;
              if (url) location.assign(url);
            }, { signal });
          });

          const associateAppFields = (root = this) => {
            const associateControl = (control) => {
              const isProductField = control.name === 'selling_plan' || control.name.startsWith('properties[');
              if (isProductField && !control.form && !control.hasAttribute('form') && form?.id) control.setAttribute('form', form.id);
            };
            if (root.matches?.('[data-product-app-block] :is(input, select, textarea)[name]')) associateControl(root);
            root.querySelectorAll?.('[data-product-app-block] :is(input, select, textarea)[name]').forEach(associateControl);
          };
          associateAppFields();
          this.appObserver = new MutationObserver((records) => {
            records.forEach((record) => record.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) associateAppFields(node);
            }));
          });
          this.querySelectorAll('[data-product-app-block]').forEach((appBlock) => this.appObserver.observe(appBlock, { childList: true, subtree: true }));

          form?.addEventListener('submit', (event) => {
            const submit = form.querySelector('[data-product-submit]');
            if (form.dataset.demoCatalogMode === 'true') {
              event.preventDefault();
              return;
            }
            if (!form.checkValidity() || submit?.disabled) {
              event.preventDefault();
              form.reportValidity();
              return;
            }
            submit.disabled = true;
            submit.setAttribute('aria-busy', 'true');
          }, { signal });

          this.querySelectorAll('[data-size-guide-open]').forEach((trigger) => {
            const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
            window.EvvelaDialog?.bind(dialog);
            trigger.addEventListener('click', () => window.EvvelaDialog?.open(dialog, trigger, '[data-dialog-close]'), { signal });
          });

          // Show one mobile purchase action only when the primary CTA has scrolled above view.
          const stickyBar = this.querySelector('.product-sticky');
          const primarySubmit = this.querySelector('[data-product-submit]');
          const mobileStickyQuery = matchMedia('(max-width: 749px)');
          const stickyPrice = stickyBar?.querySelector('.product-sticky__meta span');
          const mainPrice = this.querySelector('.product-detail__price');
          const refreshSticky = () => {
            if (!stickyBar) return;
            const isMobile = mobileStickyQuery.matches;
            const bounds = primarySubmit?.getBoundingClientRect();
            const pastPrimaryCta = bounds && bounds.bottom < 0;
            const blocked = this.dataset.demoCatalogMode === 'true' || this.querySelector('dialog[open]') != null;
            stickyBar.hidden = !isMobile || !pastPrimaryCta || blocked;
            if (stickyPrice && mainPrice && !stickyBar.hidden) {
              const price = mainPrice.innerText?.trim();
              if (price) stickyPrice.textContent = price.split('\\n')[0];
            }
          };
          let scrollRaf = 0;
          const scheduleStickyRefresh = () => {
            if (scrollRaf) return;
            scrollRaf = requestAnimationFrame(() => { scrollRaf = 0; refreshSticky(); });
          };
          window.addEventListener('scroll', scheduleStickyRefresh, { passive: true, signal });
          window.addEventListener('resize', scheduleStickyRefresh, { passive: true, signal });
          this.addEventListener('change', scheduleStickyRefresh, { signal });
          mobileStickyQuery.addEventListener?.('change', scheduleStickyRefresh, { signal });
          refreshSticky();

          this.querySelector('[data-sticky-purchase]')?.addEventListener('click', () => {
            if (this.dataset.purchaseAvailable === 'true') form?.requestSubmit();
            else {
              picker?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
              picker?.querySelector('a, select')?.focus();
            }
          }, { signal });

          if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.querySelectorAll('video[autoplay]').forEach((video) => video.pause());
          }
        }

        disconnectedCallback() {
          this.appObserver?.disconnect();
          this.appObserver = null;
          this.abortController?.abort();
          this.abortController = null;
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["utility-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.EvvelaUtility) return;
    window.EvvelaUtility = true;

    const revealShare = (root = document) => {
      if (!navigator.share) return;
      root.querySelectorAll?.('[data-utility-share]').forEach((button) => { button.hidden = false; });
    };
    revealShare();
    document.addEventListener('shopify:section:load', (event) => revealShare(event.target));

    document.addEventListener('submit', (event) => {
      const form = event.target.closest?.('[data-utility-form]');
      if (!form || !form.checkValidity()) return;
      const submitter = event.submitter;
      window.setTimeout(() => {
        if (!form.isConnected || !submitter) return;
        submitter.disabled = true;
        submitter.setAttribute('aria-busy', 'true');
      });
    });

    window.addEventListener('pageshow', () => {
      document.querySelectorAll('[data-utility-form] [aria-busy="true"]').forEach((button) => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
    });

    document.addEventListener('click', async (event) => {
      const copy = event.target.closest?.('[data-gift-card-copy]');
      if (copy) {
        const code = document.querySelector('[data-gift-card-code]')?.textContent?.trim();
        const status = document.querySelector('[data-gift-card-copy-status]');
        try {
          if (!code || !navigator.clipboard?.writeText) throw new Error();
          await navigator.clipboard.writeText(code);
          if (status) status.textContent = copy.dataset.successMessage || '';
        } catch {
          if (status) status.textContent = copy.dataset.errorMessage || '';
        }
        return;
      }
      if (event.target.closest?.('[data-gift-card-print]')) {
        window.print();
        return;
      }
      const share = event.target.closest?.('[data-utility-share]');
      if (share && navigator.share) {
        try {
          await navigator.share({ title: document.title, url: share.dataset.shareUrl || window.location.href });
        } catch {}
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["whatsapp-support"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('evvela-whatsapp-support')) return;

    customElements.define('evvela-whatsapp-support', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        const toggle = this.querySelector('[data-whatsapp-toggle]');
        const popup = this.querySelector('[data-whatsapp-popup]');
        const close = this.querySelector('[data-whatsapp-close]');
        if (!toggle || !popup) return;

        const setOpen = (open, returnFocus = false) => {
          toggle.setAttribute('aria-expanded', String(open));
          popup.hidden = !open;
          if (returnFocus && !open) toggle.focus();
        };

        toggle.addEventListener('click', () => {
          setOpen(toggle.getAttribute('aria-expanded') !== 'true');
        }, { signal });

        close?.addEventListener('click', () => setOpen(false, true), { signal });

        document.addEventListener('pointerdown', (event) => {
          if (toggle.getAttribute('aria-expanded') === 'true' && !this.contains(event.target)) setOpen(false);
        }, { signal });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') setOpen(false, true);
        }, { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
